import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=1eadde6c&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports